import axios from 'axios';

export async function getImagesByQuery(query, page) {
  const API_KEY = '55034403-f88339d3d304c1de3b7a91a97';
  const BASE_URL = 'https://pixabay.com/';
  const END_POINT = 'api/';
  const url = BASE_URL + END_POINT;

  const params = {
    key: API_KEY,
    q: query,
    image_type: 'photo',
    orientation: 'horizontal',
    safesearch: true,
    per_page: 15,
    page: page,
  };

  const response = await axios.get(url, { params });
  return response.data;
}
